// extracted by mini-css-extract-plugin
export default {"box":"Box_box__fflVC","gradient":"Box_gradient__pLuKz","header":"Box_header__OwkvL"};